import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import "./assets/native-toast.css";
import "./assets/fontawesome/css/all.min.css";
import "./assets/fonts/index.css";
import "./assets/tailwind.css";

import "vue3-carousel/dist/carousel.css";

import VueSocketIO from "vue-3-socket.io";

import VueGoogleMaps from "@fawmi/vue-google-maps";
import { API_URL } from "./config";

import { createMetaManager } from "vue-meta";

import VueScrollTo from "vue-scrollto";

import vue3GoogleLogin from "vue3-google-login";

createApp(App)
  .use(store)
  .use(router)
  .use(VueScrollTo)
  .use(createMetaManager())
  .use(vue3GoogleLogin, {
    clientId:
      "929897870268-ngm8703mplpsmttja76jk5o4slrj5naj.apps.googleusercontent.com",
  })
  .use(VueGoogleMaps, {
    load: {
      key: "AIzaSyDc9fqamcRu3iylL46AzH-a-2_vCwFSVp8",
      // language: 'de',
    },
  })
  .use(
    new VueSocketIO({
      debug: true,
      connection: API_URL,
      vuex: {
        store,
        actionPrefix: "SOCKET_",
        mutationPrefix: "SOCKET_",
      },
    })
  )
  .mount("#app");
